var _path, _path2, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 6.50012L15.0003 14.3338C15.0003 14.7004 15.0336 14.6671 14.6669 14.6671H1.33366C0.966991 14.6671 1.0003 14.7004 1.0003 14.3338L1.0003 6.50012",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00072 7.00122L1.00072 2.33455C1.00072 1.96789 0.967385 2.00122 1.33405 2.00122L14.6673 2.00122C15.034 2.00122 15.0007 1.96789 15.0007 2.33455L15.0007 7.00122",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.8998,
    x2: 10.8998,
    y2: 4,
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.1,
    x2: 5.1,
    y2: 4,
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}

export default SvgIconCalendar;